<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router'
import { scopedLogger, logInfo } from '@lib/utils/logUtils'
import { useLocale } from '@composables/useLocale'
import AdkButton from '@components/ui/AdkButton.vue'
import { useGtm } from '@composables/useGtm'

const log = scopedLogger('@components/Attract.vue')

const { t } = useLocale()
const route = useRoute()
const router = useRouter()
const { trackContinueGuest } = useGtm()

async function doContinue() {
  if (route.name === 'attract' || route.query.name === 'attract') {
    trackContinueGuest(route.name === 'attract' ? 'attract_screen' : undefined) // only override on attract which has not a page_view 
    await router.push({ name: 'anonymous-welcome' })
    return
  } else if (
    route.name === 'identification' &&
    typeof route.query.name === 'string' &&
    route.query.name !== 'anonymous-welcome' &&
    router.hasRoute(route.query.name)
  ) {
    trackContinueGuest()
    await router.push({ name: route.query.name })
    return
  }

  logInfo(log, 'Continue to Prehome')
  trackContinueGuest()
  // navigate to Prehome
  await router.push({ name: 'prehome' })
}
</script>

<template>
  <!-- TO DO adjust texts in case of changing logged/not logged behaviour -->
  <AdkButton
    data-test="btn-footer-continue-without-login"
    class="flex w-full flex-col! justify-center"
    size="extralarge"
    @press="doContinue"
  >
    <p>
      <span class="text-h3 block font-bold">
        {{ t('Continuar') }}
      </span>
      <span class="text-h5 block">
        {{ t('como_invitado') }}
      </span>
    </p>
  </AdkButton>
</template>
